// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// ★ CORRECT FIREBASE CONFIG
const firebaseConfig = {
  apiKey: "AIzaSyCV2P7xPAuxSam5Bd4Mk3NhkwZlaGBPimM",
  authDomain: "craic-on-the-case.firebaseapp.com",
  projectId: "craic-on-the-case",
  storageBucket: "craic-on-the-case.firebasestorage.app",
  messagingSenderId: "767241375654",
  appId: "1:767241375654:web:c596be224993d9b74b0967",
  measurementId: "G-0BVHJBGM78"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Auth
export const auth = getAuth(app);

// Firestore
export const db = getFirestore(app);

// Storage
export const storage = getStorage(app);

// Functions - specify the region (us-central1 based on your error)
export const functions = getFunctions(app, "us-central1");

// Uncomment these lines if testing locally:
// connectAuthEmulator(auth, "http://localhost:9099");
// connectFunctionsEmulator(functions, "localhost", 5001);